import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";
import StaffForm from "../components/StaffForm";

export default function StaffAdd() {

    const saveStaff = (form: any) => {
        const requester = new Requester();

        const data = new FormData();

        Object.keys(form).forEach((key) => {
            data.append(key, form[key]);
        });

        requester.post(requester.getUrl(`api/staff`), data).then((response) => {
            router.visit(`/admin/staff`);
        }).catch((error) => {
            alert("Error adding staff: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Staff" />
            <ContentWrapper>
                <StaffForm onSubmit={saveStaff} />
            </ContentWrapper>
        </App >
    )
}